import Box from 'components/atomic/atoms/box'
import Text from 'components/atomic/atoms/text'

const HomepageSectionTitle = (props: {
  title: string
  label?: 'In Progress' | 'Planned'
}) => {
  const { title } = props

  return (
    <Box flex="column" items="center">
      <Text
        as="h2"
        weight="bold"
        size={{ '@initial': '4xl', '@sm': '5xl' }}
        align="center"
        css={{
          mt: '$4'
        }}
      >
        {title}
      </Text>
    </Box>
  )
}

export default HomepageSectionTitle
